const utm_source = 'utm_source';
const utm_medium = 'utm_medium';
const utm_campaign = 'utm_campaign';
const utm_term = 'utm_term';
const utm_content = 'utm_content';

const utm_params_keys = [
  utm_source,
  utm_medium,
  utm_campaign,
  utm_term,
  utm_content,
];

export const getUtmParams = (): string => {
  const urlParams = new URLSearchParams(window.location.search);
  const utm_obj: Record<string, string> = {};

  utm_params_keys.forEach(param => {
    utm_obj[param] = urlParams.get(param) || '';
  });

  return new URLSearchParams(utm_obj).toString();
};

export const parseUtmParams = (queryString: string): Record<string, string> => {
  const params = new URLSearchParams(queryString);
  const result: Record<string, string> = {};

  utm_params_keys.forEach(key => {
    result[key] = params.get(key) || '';
  });

  return result;
};

export const getClickIds = (): { fbclid: string; gclid: string } => {
  const urlParams = new URLSearchParams(window.location.search);
  return {
    fbclid: urlParams.get('fbclid') || '',
    gclid: urlParams.get('gclid') || '',
  };
};

const FARE_ESTIMATE_REDIRECT_SOURCE = 'trucks_fare_estimate';
const redirect_utm_defaults: Record<string, string> = {
  [utm_source]: 'website_fare_estimate_ssr',
  [utm_medium]: `default_${FARE_ESTIMATE_REDIRECT_SOURCE}`,
  [utm_campaign]: `default_${FARE_ESTIMATE_REDIRECT_SOURCE}`,
  [utm_term]: `default_${FARE_ESTIMATE_REDIRECT_SOURCE}`,
  [utm_content]: '',
};

export const withRedirectUtmDefaults = (utmQuery: string): string => {
  const params = new URLSearchParams(utmQuery);
  utm_params_keys.forEach(key => {
    if (!params.get(key)) {
      params.set(key, redirect_utm_defaults[key]);
    }
  });
  return params.toString();
};
